import React, { ReactNode, createContext, useContext, useState } from 'react';

import { WorklistViewModel } from 'models';

interface FileViewerContextType {
  stackName?: string;
  selectedWorklist?: WorklistViewModel | null;
  allWorklists?: WorklistViewModel[] | null;
  currentPath?: string;
  setStackName: (name: string | undefined) => void;
  setSelectedWorklist: (worklist: WorklistViewModel | null) => void;
  setAllWorklists: (worklists: WorklistViewModel[] | null) => void;
  setCurrentPath: (path: string) => void;
}

const FileViewerContext = createContext<FileViewerContextType | null>(null);

interface FileViewerProviderProps {
  children: ReactNode;
}

export const FileViewerProvider: React.FC<FileViewerProviderProps> = ({ children }) => {
  const [stackName, setStackName] = useState<string | undefined>();
  const [selectedWorklist, setSelectedWorklist] = useState<WorklistViewModel | null>(null);
  const [allWorklists, setAllWorklists] = useState<WorklistViewModel[] | null>(null);
  const [currentPath, setCurrentPath] = useState<string>('');

  const value: FileViewerContextType = {
    stackName,
    selectedWorklist,
    allWorklists,
    currentPath,
    setStackName,
    setSelectedWorklist,
    setAllWorklists,
    setCurrentPath,
  };

  return <FileViewerContext.Provider value={value}>{children}</FileViewerContext.Provider>;
};

export const useFileViewerContext = (): FileViewerContextType => {
  const context = useContext(FileViewerContext);
  if (!context) {
    throw new Error('useFileViewerContext must be used within a FileViewerProvider');
  }
  return context;
};
